<ub-card [variant]="bookingItem.workflow.state === 'published' ? 'success' : 'warn'" [rounded]="true"
  [dividers]="false">
  <h3 title><a [routerLink]="[bookingItem.doc._id, 'view']">{{ bookingItem.doc.name ?? bookingItem.doc._id }}</a></h3>
  <div content>
    <div *ngIf="bookingOption$ | async; let bookingItemOption">
      <ub-label *ngIf="bookingItemOption.summary.openOptions" label="Booking status" text="OPEN" variant="success" i18n-label i18n-text></ub-label>
      <ub-label *ngIf="!bookingItemOption.summary.openOptions" label="Booking status" text="CLOSED" variant="" i18n-label i18n-text></ub-label>
      <ub-label label="State" text="{{ bookingItem.workflow.title }}" i18n-label></ub-label>
      <ub-label *ngIf="bookingItemOption.summary.bookingDates?.min" label="Date" i18n-label>
        <span text>
          {{ bookingItemOption.summary.bookingDates | easDateRange: timezone:bookingItemOption.bookingDates?.timezone }}
        </span>
      </ub-label>

      <ub-label *ngIf="bookingItemOption.summary.bookingWindow?.min" label="Booking window" i18n-label>
        <span text>
          {{ bookingItemOption.summary.bookingWindow | easDateRange: timezone:bookingItemOption.bookingWindow?.timezone }}
        </span>
      </ub-label>

      <ub-label *ngIf="bookingItemOption.summary.openOptions" label="Open options" i18n-label>
        <span text>
          {{ bookingItemOption.summary.openOptions }}
        </span>
      </ub-label>

      <ub-label *ngIf="bookingItemOption.summary.price.min !== null" label="Price" i18n-label>
        <span text>{{ bookingItemOption.summary.price| easPriceRange: bookingItemOption.summary.price.currency }}</span>
      </ub-label>
    </div>
    <eas-translation-info-list *ngIf="bookingItem.doc.translationInfo" [translationInfo]="bookingItem.doc.translationInfo">
    </eas-translation-info-list>
  </div>
  <div actions>
    <eas-buttons-menu *ngIf="buttons" [buttons]="buttons"></eas-buttons-menu>
  </div>
</ub-card>
